// Copyright (C) 2017-2023 Smart code 203358507

const MetaDetails = require('./MetaDetails');

module.exports = MetaDetails;
